module.exports = __webpack_public_path__ + "img/yakiton_hibarigaoka.6274743b.jpg";